import React from "react";
import styles from "./header-title.module.scss";

interface HeaderTitleProps {
  title?: string;
  subtitle?: string;
}

export const HeaderTitle: React.FC<HeaderTitleProps> = ({
  title,
  subtitle
}) => {
  return (
    <div className={styles.header}>
      <span className={styles.header__title}>{title}</span>
      <span className={styles.header__subtitle}>{subtitle}</span>
      <hr className={styles.header__line}></hr>
    </div>
  );
};
